/* unplugin-vue-components disabled */import { render } from "./ingest.vue?vue&type=template&id=6f04717e&scoped=true"
import script from "./ingest.vue?vue&type=script&lang=js"
export * from "./ingest.vue?vue&type=script&lang=js"

import "./ingest.vue?vue&type=style&index=0&id=6f04717e&lang=stylus&scoped=true"

import exportComponent from "/home/runner/work/buzz-front/buzz-front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6f04717e"],['__file',"src/pages/settings/superuser/ingest/ingest.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "6f04717e"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('6f04717e', __exports__)) {
    api.reload('6f04717e', __exports__)
  }
  
  module.hot.accept("./ingest.vue?vue&type=template&id=6f04717e&scoped=true", () => {
    api.rerender('6f04717e', render)
  })

}


export default __exports__